import WellingtonHeroSection from "./components/HeroSection";
import WellingtonStickyNav from "./components/StickyNav";
import WellingtonProcessingTimeSection from "./components/ProcessingTimeSection";
import WellingtonServicesSection from "./components/ServicesSection";
import WellingtonLocalAreaSection from "./components/LocalAreaSection";
import WellingtonTravelTimingSection from "./components/TravelTimingSection";
import WellingtonDestinationsSection from "./components/DestinationsSection";
import WellingtonTestimonialsSection from "./components/TestimonialsSection";
import WellingtonAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WellingtonComparisonSection from "./components/ComparisonSection";
import WellingtonMistakesSection from "./components/MistakesSection";
import WellingtonHowItWorksSection from "./components/HowItWorksSection";
import WellingtonFAQSection, { faqs } from "./components/FAQSection";
import WellingtonHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WellingtonFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WellingtonPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wellington"
        state="Florida"
        stateAbbr="FL"
        route="/wellington"
        title="Emergency Passport Wellington, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Wellington, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Palm Beach County equestrians, polo families, and travelers."
        geoPlacename="Wellington, Florida"
        geoPosition="26.6618;-80.2684"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <WellingtonHeroSection />
      <WellingtonStickyNav />
      <WellingtonProcessingTimeSection />
      <WellingtonLocalAreaSection />
      <WellingtonServicesSection />
      <WellingtonTravelTimingSection />
      <WellingtonDestinationsSection />
      <WellingtonTestimonialsSection />
      <WellingtonAcceptanceFacilitiesSection />
      <WellingtonComparisonSection />
      <WellingtonMistakesSection />
      <WellingtonHowItWorksSection />
      <WellingtonFAQSection />
      <WellingtonHelpfulResourcesSection />
      <WellingtonFinalCTA />
    </div>
  );
}